<template>
    <DsModal
        show-back
        :is-open="isOpen"
        :title="$t('unlayerBuilder.sendTestEmail.dropdownAddText')"
        data-qa="custom-recipient-modal"
        @back="$emit('back')"
    >
        <template #default>
            <form ref="customRecipientForm" novalidate>
                <DsInputField
                    v-model="name"
                    :label="$t('global.name')"
                    trim
                    data-qa="custom-recipient-name-input"
                    :submitted="formSubmitted"
                />

                <DsInputField
                    v-model="email"
                    :label="$t('unlayerBuilder.sendTestEmail.customRecipient.emailAddressLabel')"
                    type="email"
                    trim
                    required
                    data-qa="custom-recipient-email-input"
                    :pattern="$options.EMAIL_REGEX"
                    :submitted="formSubmitted"
                >
                    <template #error>
                        <span> {{ $t('forms.error.businessEmail') }} </span>
                    </template>
                </DsInputField>
            </form>

            <div>
                <DsFilledButton
                    data-qa="save-custom-recipient-button"
                    @click="saveCustomRecipient"
                >
                    {{ $t('global.save') }}
                </DsFilledButton>
            </div>
        </template>
    </DsModal>
</template>

<script>
import { patterns } from '@/utils/email.util';

export default {
    EMAIL_REGEX: patterns.email,

    name: 'SendTestEmailCustomRecipientModal',

    props: {
        isOpen: Boolean,
    },

    data() {
        return {
            name: '',
            email: '',
            formSubmitted: false,
        };
    },

    watch: {
        isOpen(value) {
            if (value) {
                this.formSubmitted = false;
            }
        },
    },

    methods: {
        async saveCustomRecipient() {
            this.formSubmitted = true;

            const isFormValid = this.$refs.customRecipientForm.checkValidity();

            if (!isFormValid) return;

            this.$emit('recipient-added', {
                name: this.name,
                email: this.email,
            });

            this.formSubmitted = false;
            this.name = '';
            this.email = '';
        },
    },
};
</script>
